<template>
  <PageMain class="bg-w mt-20 ">
    <!-- <div class="fs-20 fs-b f-c-b mb-20 pt-20 pl-20 pr-20">寄件统计</div> -->
    <a-tabs v-model="tab" type="card" class="search-tab pt-20">
      <a-tab-pane :key="1" tab="订单统计">
        <Tab1 />
      </a-tab-pane>
      <a-tab-pane :key="2" tab="账单统计" force-render>
        <Tab2 />
      </a-tab-pane>
    </a-tabs>
  </PageMain>
</template>
<script>

/**
 * 如何使用vue
 * 这里做最基本的用法演示，详细请看vue的官网
 * https://cn.vuejs.org/v2/guide/
 */
import Tab1 from './tab1'
import Tab2 from './tab2'

export default {
  name: 'Send',
  components: {
    Tab1, Tab2
  },
  data() {
    return {
      tab: 1
    }
  },
  created() {
    this.$route.query.tab ? this.tab = +this.$route.query.tab : ''
  }

}
</script>

<style lang="scss" >
.search-tab{
  .ant-tabs-nav-scroll{
  padding: 0 20px;

  }
}
</style>
